module.exports = __webpack_public_path__ + "static/media/kushner-davos.310975fa.png";